export default __webpack_public_path__ + "static/media/2000-AMcover.a653a16c.png";